// @flow
export const SELECT_VALUE: string = 'SELECT_VALUE'
export const SELECTED_HAS_RELATED: string = 'SELECTED_HAS_RELATED'
export const DESELECT_VALUE: string = 'DESELECT_VALUE'
export const CHANGE_SEARCH_VALUE: string = 'CHANGE_SEARCH_VALUE'
export const FILTER_SUGGESTIONS: string = 'FILTER_SUGGESTIONS'



// WEBPACK FOOTER //
// ./src/shared/actionTypes/searchTypes.js